import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@scentregroup/ui'
import ResponsiveImage from '../responsive-image'
import style from './index.module.scss'

const Logo = ({ name, logo }) =>
  logo.src ? (
    <ResponsiveImage
      className={style.logo}
      desktopImageUrl={logo.src}
      mobileImageUrl={logo.src}
      // The name of the shop is right below, so screen readers would read it
      // twice if we also included it here
      alt=""
      desktopRatio="square"
      mobileRatio="square"
      numberOfItems={4}
      bgSize="contain"
    />
  ) : (
    <div className={style.logo}>
      <div aria-hidden="true" className={style.nologoWrapper}>
        <Heading type="extrasmall" className={style.nologo}>
          {name}
        </Heading>
      </div>
    </div>
  )

Logo.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.shape({
    src: PropTypes.string,
  }),
}

export default Logo
